module.exports = __webpack_public_path__ + "static/media/moto.d7724846.png";